// @flow

import type { AttributeNameValue, GenericEventConfig, ProductItem } from '@chatchamp/chatchamp-types'

import { WelcomeMessage } from '../chatbot/models'
// TODO; Dominik; 31.08.2023; this cannot be shortened for now; we need to refactor the close coupling of GA and Tealium events first
// see README of event tracking
import { type EventSenderType } from '../main/eventTracking/types'

export type SetItemIframePayload = {
  event: string,
  key: string,
  value: any,
  maxAgeDays?: number
}

export type JavaScriptPayload = {
  javascript: string
}

export type EventPayload = {
  event: string, // TrackingEvent
  eventSender?: EventSenderType,
  chatbotId?: string,
  products?: Array<ProductItem>,
  product?: ProductItem,
  productId?: string,
  productIds?: string,
  welcomeMessage?: WelcomeMessage,
  url?: string,
  attribute?: AttributeNameValue
}

export type IframePayload = {
  event: string,
  subscriberId?: string,
  customerId?: string,
  value?: any,
  googleAnalytics?: GenericEventConfig,
  productId?: string,
  productIds?: string,
  size?: {
    height: number,
    width: number
  },
  type?: string,
  welcomeMessage?: WelcomeMessage,
  chatbotId?: string,
  url?: string,
  key?: string,
  eventSender?: EventSenderType,
  products?: Array<ProductItem>,
  product?: ProductItem,
  loadedMoreProducts?: boolean,
  attribute?: AttributeNameValue
}

export const MESSAGE_TYPE_WELCOME_MESSAGE_SHOWN = 'welcome_message_shown'
export const MESSAGE_TYPE_WELCOME_MESSAGE_CLICKED = 'welcome_message'
export const MESSAGE_TYPE_WELCOME_MESSAGE_CLOSED = 'welcome_message_closed'
export const MESSAGE_TYPE_ADD_TO_CART = 'add_to_cart'
export const MESSAGE_TYPE_PRODUCT_BUTTON = 'product_button'
export const MESSAGE_TYPE_CLOSED = 'closed'
export const MESSAGE_TYPE_CUSTOMER_SUPPORT = 'customer-support'
export const MESSAGE_TYPE_CLOSING = 'closing'
export const MESSAGE_TYPE_JAVASCRIPT = 'javascript'
export const MESSAGE_TYPE_GOOGLE_ANALYTICS = 'googleAnalytics'
export const MESSAGE_TYPE_STARTED = 'started'
export const MESSAGE_TYPE_LOADED = 'loaded'
export const MESSAGE_TYPE_OPENING = 'opening'
export const MESSAGE_TYPE_CHAT_ICON_CLICKED = 'clicked'
export const MESSAGE_TYPE_RESTART = 'restart'
export const MESSAGE_TYPE_IMAGE = 'image'
export const MESSAGE_TYPE_URL_BUTTON = 'url_button'
export const MESSAGE_TYPE_PRODUCTS = 'products'
export const MESSAGE_TYPE_SET_ITEM = 'set_item'
export const MESSAGE_TYPE_WIZARD = 'wizard'
export const MESSAGE_TYPE_TUNNEL_CHATBOT_EVENTS = 'chatbot_events'
export const MESSAGE_TYPE_USER_ATTRIBUTE_SET = 'user_attribute_set'
